<h1 mat-dialog-title>Welcome to Team Xpress! 🎉</h1>
<div mat-dialog-content>
  <p>
    Congratulations! Your business has been approved to join our platform. We're
    excited to have you as part of our growing community of merchants.
    <br>
    Just a few quick steps remain to get your store up and running:
  </p>
  <ul class="mt-3">
    <li>Set up your store location and delivery radius</li>
    <li>Add your products</li>
    <li>Add your Employees</li>
    <li>Set up your payment details</li>
  </ul>

  <p class="mt-1">
    Once you complete these steps, you'll be ready to receive orders and grow
    your business with Xpress. Our team is here to support you every step of the
    way.Ready to get started? Click below to begin your store setup.
  </p>
</div>
<div mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    cdkFocusInitial
    (click)="launchMyStore()"
    [disabled]="loading"
    class="mb-3 mr-3"
  >
    Launch my Store
  </button>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
